import { useCreateAppointmentNotificationMutation } from "../../../api/appointments/useCreateAppointmentNotificationMutation";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { uiNotification } from "../../../services/UINotificationService";
import { extractApiError } from "../../../utilities/api";

export function useCreateAppointmentNotification() {
  const languageData = JSON.parse(localStorage.getItem("languageData"));
  const { tCommon: t } = useAppTranslation.Common();

  const { mutateAsync, isLoading } = useCreateAppointmentNotificationMutation({
    onSuccess: () => {
      uiNotification.success("Notification sent successfully");
    },
    onError: (error) => {
      const message = extractApiError(error);
      uiNotification.error(
        t(`error.${message}`, languageData.global[message] || message),
      );
    },
  });

  return {
    createAppointmentNotification: mutateAsync,
    isAppointmentNotificationCreating: isLoading,
  };
}
